import React from 'react'

const Subscription = ({ width, height }) => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 12.263 13.706"
      >
        <path
          data-name="Path 939"
          d="M3.5 4.3a1.8 1.8 0 0 1 1.8-1.8h7.214a1.8 1.8 0 0 1 1.8 1.8v3.971a.361.361 0 0 1-.721 0V4.3a1.082 1.082 0 0 0-1.082-1.082H5.3A1.082 1.082 0 0 0 4.221 4.3v10.1A1.082 1.082 0 0 0 5.3 15.485h5.05a.361.361 0 0 1 0 .721H5.3a1.8 1.8 0 0 1-1.8-1.8z"
          transform="translate(-3.5 -2.5)"
          style={{ fill: '#b1b1b1' }}
        />
        <path
          data-name="Path 940"
          d="M14.517 10.992a.361.361 0 0 1 .361.361v.481H15a1.264 1.264 0 0 1 1.321 1.2.361.361 0 0 1-.721 0 .547.547 0 0 0-.6-.48h-1.087a.436.436 0 0 0-.478.372c0 .154.038.206.06.229a.569.569 0 0 0 .252.122l1.744.506a1.25 1.25 0 0 1 .574.32 1.014 1.014 0 0 1 .255.723 1.151 1.151 0 0 1-1.2 1.094h-.243v.48a.361.361 0 0 1-.721 0v-.481h-.122a1.264 1.264 0 0 1-1.321-1.2.361.361 0 1 1 .721 0 .547.547 0 0 0 .6.48h1.086a.436.436 0 0 0 .478-.372c0-.154-.038-.206-.06-.229a.569.569 0 0 0-.252-.122l-1.744-.506a1.25 1.25 0 0 1-.574-.32 1.014 1.014 0 0 1-.255-.723 1.151 1.151 0 0 1 1.2-1.094h.243v-.481a.361.361 0 0 1 .361-.361m-8.3-1.8a.361.361 0 0 1 .361-.361h.361a.361.361 0 1 1 0 .721h-.357a.361.361 0 0 1-.361-.361m2.164 0a.361.361 0 0 1 .361-.361h3.607a.361.361 0 1 1 0 .721H8.746a.361.361 0 0 1-.361-.361m-2.164 2.164a.361.361 0 0 1 .361-.361h.361a.361.361 0 1 1 0 .721h-.361a.361.361 0 0 1-.361-.361m2.164 0a.361.361 0 0 1 .361-.361h2.525a.361.361 0 0 1 0 .721H8.746a.361.361 0 0 1-.361-.361m-2.164 2.166a.361.361 0 0 1 .361-.361h.361a.361.361 0 1 1 0 .721h-.361a.361.361 0 0 1-.361-.361m2.164 0a.361.361 0 0 1 .361-.361h1.443a.361.361 0 0 1 0 .721H8.746a.361.361 0 0 1-.361-.361M6.426 4.5h6.083c.091 0 .18 0 .255.006a.74.74 0 0 1 .278.073.721.721 0 0 1 .315.315.712.712 0 0 1 .072.278c.006.075.006.164.006.255v1.032c0 .091 0 .18-.006.255a.7.7 0 0 1-.665.665q-.127.008-.255.006H6.426c-.091 0-.18 0-.255-.006a.7.7 0 0 1-.665-.666Q5.5 6.587 5.5 6.459V5.426c0-.091 0-.18.006-.255a.74.74 0 0 1 .073-.278.7.7 0 0 1 .593-.387Q6.3 4.5 6.426 4.5m-.2.726v1.43h6.482v-.001q.006-.1 0-.208V5.226q-.1-.006-.208 0H6.226"
          transform="translate(-4.057 -3.057)"
          style={{ fill: '#b1b1b1' }}
        />
      </svg>
    </div>
  )
}

export default Subscription
